import {
  Box,
  ConnectedField,
  Link,
  SearchFacets,
  SearchForm,
  SearchResults,
  SearchTags,
  SearchTermsInput,
  Section,
  Stack,
  Text,
} from 'quickstart/components'
import {UseSearchReturn} from 'quickstart/hooks'
import {formFields} from 'quickstart/lib/search/config'
import {useUp} from 'quickstart/styled-components/system'
import * as R from 'rambdax'
import {useMemo} from 'react'
import {logger} from 'tizra'

const log = logger('SearchBlock/Results')

interface ResultsProps {
  search: UseSearchReturn
  showPageThumbnails: boolean
  switchToAdvanced: () => void
}

export const Results = ({
  search,
  search: {config},
  showPageThumbnails,
  switchToAdvanced,
}: ResultsProps) => {
  // Technically the terms field can be configured out, though this would need
  // some UX design before it would be a usable configuration.
  const termsField = useMemo(
    () => formFields(config, 'desktopFilters').find(R.propEq('terms', 'name')),
    [config],
  )

  const facetsBreakpoint = 'lg'
  const includeFacets = useUp(facetsBreakpoint)

  return (
    <Section>
      <Box
        display="grid"
        gap="2rem"
        cols={{[facetsBreakpoint]: '25% minmax(0, 1fr)'}}
      >
        {includeFacets && <SearchFacets search={search} />}
        <Stack spacing="xl" wrapChildren={false}>
          <Stack wrapChildren={false}>
            <Stack row spacing="lg" style={{alignItems: 'baseline'}}>
              <Text variant="h1">Search</Text>
              <Link variant="ui" onClick={switchToAdvanced}>
                Use advanced search
              </Link>
            </Stack>
            {termsField && (
              <SearchForm search={search}>
                <ConnectedField
                  autoFocus
                  component={SearchTermsInput}
                  name="terms"
                  search={search}
                  tips={termsField.tips}
                />
              </SearchForm>
            )}
          </Stack>
          <SearchTags search={search} />
          <SearchResults
            search={search}
            showPageThumbnails={showPageThumbnails}
          />
        </Stack>
      </Box>
    </Section>
  )
}
